export default __webpack_public_path__ + "static/media/circle-plus.c7a8e5a7.svg";